export const formatDollarAmount = (amount, locale, compact = false, tuncFraction = false) => {
    if (amount == null)
        return '-';
    const options = {
        style: 'currency',
        currency: 'CAD',
    };
    // when compact is explicitly enabled or compact digit limit is exceeded
    const showCompact = compact == true || (typeof compact == 'number' && compact < amount.toString().length);
    if (showCompact)
        options.notation = 'compact';
    if (tuncFraction) {
        options.minimumFractionDigits = showCompact ? 2 : 0;
        options.maximumFractionDigits = showCompact ? 2 : 0;
    }
    return new Intl.NumberFormat(locale, options).format(amount);
};
export const formatNumber = (number, maxDigit) => {
    if (number == null)
        return '-';
    if (maxDigit == null)
        return number.toLocaleString();
    if (number.toString().length <= maxDigit)
        return number.toLocaleString();
    // Handle max digit
    return '9'.repeat(maxDigit) + '+';
};
export const formatPercentage = (number, maxDigit) => {
    if (number == null)
        return '-';
    const strVersion = (number * 100).toFixed(0);
    if (!maxDigit || strVersion.length <= maxDigit)
        return strVersion + '%';
    // Handle max digit
    return '9'.repeat(maxDigit) + '%';
};
export const formatMCCName = (name) => {
    const words = name.split(' ');
    return words.map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};
export const formatPostalCode = (postalCode) => {
    if (postalCode.match(/([A-Z][0-9]){3}/gm)) {
        // need to insert a space
        return postalCode.slice(0, 3) + ' ' + postalCode.slice(3, 6);
    }
    return postalCode;
};
